import { MeasurementsTimeline } from "./MeasurementTimeline/MeasurementsTimeline";
import type { WorkflowReducer } from "../workflowReducer";

interface Props {
  workflowReducer: WorkflowReducer;
  editMode?: boolean;
}

export function MeasurementsTab(props: Props) {
  return <MeasurementsTimeline workflowReducer={props.workflowReducer} editMode={props.editMode} />;
}
